module.exports = __webpack_public_path__ + "img/JQuery.ae3d1394.png";